import { EntityState } from '@reduxjs/toolkit';
import { DevBoxAddOn } from '../../models/add-ons';
import { Entity } from '../../models/common';
import { SerializableMap } from '../../types/serializable-map';
import { UnionMap } from '../../types/union-map';
import { createInitializer } from '../../utilities/initializer';
import { statusAdapter } from '../adapters/common/status-adapter';
import { devBoxAddOnsAdapter } from '../adapters/dev-box-add-ons-adapters';
import { IndexedStatusStore } from './indexed-status-store';

type IndexedStatusName =
    | 'listDevBoxAddOns'
    | 'enableDevBoxAddOn'
    | 'enableDevBoxAddOnWithPolling'
    | 'createOrReplaceDevBoxAddOn';

export type DevBoxTunnelPhase = 'StartDevBox' | 'TunnelEnabling' | 'TunnelEnablingFinished' | 'TunnelNotEnabled';

export const DevBoxTunnelPhase: UnionMap<DevBoxTunnelPhase> = {
    StartDevBox: 'StartDevBox',
    TunnelEnabling: 'TunnelEnabling',
    TunnelEnablingFinished: 'TunnelEnablingFinished',
    TunnelNotEnabled: 'TunnelNotEnabled',
};

export interface DevBoxAddOnsDataStore {
    devBoxAddOns: EntityState<Entity<DevBoxAddOn[]>>;
    devBoxTunnelPhases: SerializableMap<DevBoxTunnelPhase>;
}
export const DevBoxAddOnsDataStore = createInitializer<DevBoxAddOnsDataStore>({
    devBoxAddOns: devBoxAddOnsAdapter.getInitialState(),
    devBoxTunnelPhases: {},
});

export type AddOnsStatusStore = IndexedStatusStore<IndexedStatusName>;

export const AddOnsStatusStore = createInitializer<AddOnsStatusStore>({
    listDevBoxAddOns: statusAdapter.getInitialState(),
    enableDevBoxAddOn: statusAdapter.getInitialState(),
    enableDevBoxAddOnWithPolling: statusAdapter.getInitialState(),
    createOrReplaceDevBoxAddOn: statusAdapter.getInitialState(),
});

export interface AddOnsStore {
    status: AddOnsStatusStore;
    data: DevBoxAddOnsDataStore;
}

export const AddOnsStore = createInitializer<AddOnsStore>({
    status: AddOnsStatusStore(),
    data: DevBoxAddOnsDataStore(),
});
